export const imagesHaveChanged = (images1, images2) => {
  if (!images1 && !!images2) return true;
  if (!images2 && !!images1) return true;
  if (!images1 && !images2) return false;
  if (Array.isArray(images1) !== Array.isArray(images2)) return true;
  if (!Array.isArray(images1)) return false;
  if (images1.length !== images2.length) return true;
  for (let i = 0; i < images1.length; i++) {
    const image1 = images1[i];
    let found = false;
    for (let j = 0; j < images2.length; j++) {
      const image2 = images2[j];
      if (image1.base === image2.base) {
        found = true;
        j = images2.length;
      }
    }
    if (found === false) return true;
  }
  return false;
};
